var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',[(_vm.fieldsData.fieldType =='TextView'&&_vm.fieldsData.visible==1)?_c('b',{domProps:{"innerHTML":_vm._s(_vm.fieldsData.label[_vm.selectlang])}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }